[
   {
      "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
      "moduleAssignmentUuid":"a998e96e-dbaa-4660-9a8d-22e4a5f36afc",
      "moduleAssignmentName":"Rukagen Objection Handling"
   }
]